import { useCurrentUserContext } from '@/contexts';
import { getSigninUrl } from '@/features/interactions/addToGoogle/auth.lib';
import { getAuthUrl as getOutlookAuthUrl } from '@/features/interactions/addToOutlook/auth.lib';
import { useIsExtension } from '@/features/magic/hooks/useIsExtension';
import type { DecoratedIntegration } from '@/pages/Schedule/hooks/useIntegrations';
import { IntegrationType } from '@/types/gql.generated';
import { Button } from '@/ui';

type Props = {
  integration: DecoratedIntegration;
};

export const ReconnectButton = ({ integration }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const { isExtension } = useIsExtension();

  const signinUrl =
    integration.type === IntegrationType.OutlookCalendar
      ? getOutlookAuthUrl({}, { email: integration.externalId })
      : getSigninUrl(
          currentUser,
          location.pathname,
          {},
          {
            email: integration.externalId,
          }
        );

  return (
    <Button
      as="a"
      colorScheme="dark"
      href={signinUrl}
      size="xs"
      target={isExtension ? '_blank' : '_self'}
      variant="secondary"
    >
      Enable Magic
    </Button>
  );
};
